const Footer = () => {
  return (
    <footer className="App-footer">
      <div className="wrapper">
        <p>Created at<a href="https://junocollege.com/">Juno College of Techonology</a> by Mao</p>
      </div>
    </footer>
  )
}

export default Footer;